/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTenantPermissionsScopeFilter } from './userTenantPermissionsScopeFilter';
import { UserTenantPermissionsIncludeFilterItems } from './userTenantPermissionsIncludeFilterItems';


export interface UserTenantPermissionsIncludeFilterInner { 
    relation?: UserTenantPermissionsIncludeFilterInner.RelationEnum;
    scope?: UserTenantPermissionsScopeFilter;
}
export namespace UserTenantPermissionsIncludeFilterInner {
    export type RelationEnum = 'user_tenant_id';
    export const RelationEnum = {
        UserTenantId: 'user_tenant_id' as RelationEnum
    };
}


